import { component } from 'picoapp'
import ImageCompare from 'image-compare-viewer'

class ImageCompareViewer {
  constructor(node, ctx) {
    // bindings

    // selectors
    this._node = node;

    // image compare...
    const element = this._node.querySelector(".image-compare");
    const options = {
      controlColor: "#f6e6e5",
      controlShadow: false,
      addCircle: true,
      addCircleBlur: true,
      showLabels: false,
      smoothing: true,
      smoothingAmount: 100,
      hoverStart: false,
      verticalMode: false,
      startingPoint: 50,
      fluidMode: false
    };

    const viewer = new ImageCompare(element, options).mount();

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Handle unmount.
  //
  unmount() {

  }
}

export default component((node, ctx) => new ImageCompareViewer(node, ctx))
